import BaseCRUDReducer from './CRUDReducer';
import { VoDActions } from '../actions/vod';

const CRUDReducer = new BaseCRUDReducer(new VoDActions());

export default (state, action) => CRUDReducer.run(state, action);



// WEBPACK FOOTER //
// ./src/reducers/vod.js